import React from 'react';
import { baseUrl } from '../config';
import SEO from '../components/SEO';



const CompanyDetails = () => {
  const companyDetails = JSON.parse(localStorage.getItem('companyDetails'));
  const defaultAvatar = 'https://via.placeholder.com/150'; // URL of a placeholder avatar image

  return (
    <div className="bg-gray-100 p-6">
      <SEO
        title="Company Details"
        description="View and edit your production company details on ProducerBuddy."
        url="https://producerbuddy.pilomation.com/company-details"
        robots="noindex, nofollow"
      />
      <h1 className="text-4xl font-bold text-center mb-6">Company Details</h1>
      <div className="max-w-lg mx-auto bg-white p-6 rounded-lg shadow-md">
        {companyDetails ? (
          <>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">{companyDetails.name}</h2>
            
            <div className="mb-4">
              <h3 className="text-xl font-semibold">CEO: {companyDetails.ceo}</h3>
              <img
                src={companyDetails.ceoImage || defaultAvatar}
                alt="CEO"
                className="w-32 h-32 rounded-full object-cover mt-2"
              />
            </div>
            
            <div className="mb-4">
              <h3 className="text-xl font-semibold">COO: {companyDetails.coo}</h3>
              <img
                src={companyDetails.cooImage || defaultAvatar}
                alt="COO"
                className="w-32 h-32 rounded-full object-cover mt-2"
              />
            </div>
            
            <div className="mb-4">
              <h3 className="text-xl font-semibold">CTO: {companyDetails.cto}</h3>
              <img
                src={companyDetails.ctoImage || defaultAvatar}
                alt="CTO"
                className="w-32 h-32 rounded-full object-cover mt-2"
              />
            </div>
            
            <p className="text-gray-600 text-lg">{companyDetails.history}</p>
          </>
        ) : (
          <p className="text-gray-600">No company details available.</p>
        )}
      </div>
    </div>
  );
};

export default CompanyDetails;

